import React, { useMemo } from 'react'
import PropTypes from 'prop-types/prop-types'
import classNames from 'classnames'
import { useHideToggle } from '../hooks/useHideToggle'

const Row = (props) => {
  const {
    name,
    styleNames,
    childIndex,
    hide = false,
    header,
    children
  } = props

  PropTypes.checkPropTypes(Row.propTypes, props, 'prop', 'Row')

  const hideInternal = useHideToggle(name, hide)

  const attributes = useMemo(() => {
    return {
      ...name && { id: name },
      className: classNames(
        'g-row',
        `child-${childIndex}`,
        { 'g-row-header': header },
        { [styleNames]: !!styleNames },
        { hidden: hideInternal }
      )
    }
  }, [hideInternal])

  return (
    <div {...attributes}>{children}</div>
  )
}

Row.propTypes = {
  name: PropTypes.string,
  styleNames: PropTypes.string,
  childIndex: PropTypes.number,
  hide: PropTypes.bool,
  header: PropTypes.bool,
  children: PropTypes.node
}

export default Row
